import { FileOutlined } from '@ant-design/icons';
import { getGetFrontRichiesteIdProcuratoreQueryOptions } from '@framework/api-client/api/inquiries-compile/richieste-controller/richieste-controller.ts';
import { type InfoProcura } from '@framework/api-client/api/inquiries-compile/schemas/infoProcura.ts';
import { useAuthDownload } from '@framework/common-web/utils/download/useAuthDownload.ts';
import { getNetworkErrorMessage } from '@framework/ui/core/errors/getNetworkErrorMessage.tsx';
import { Button, message } from 'antd';

export interface IAttorneyDownloadDelegationFileButtonProps {
  submissionId: string;
  fileId: string | null | undefined;
}

/**
 * Pulsante che permette di scaricare il file di procura del procuratore,
 * se è stato caricato in fase di creazione della delega.
 * Disponibile sia per il front che per il back office.
 */
export function AttorneyDownloadDelegationFileButton(
  props: IAttorneyDownloadDelegationFileButtonProps,
) {
  const { fileId, submissionId } = props;

  const { download, isFetching } = useAuthDownload(
    getGetFrontRichiesteIdProcuratoreQueryOptions,
    [props.submissionId!, { includiFile: true }],
    {
      filename: (data?: InfoProcura) => {
        return data?.datiProcura?.nomeFile ?? `Procura_${submissionId}.pdf`;
      },
      mimetype: 'application/pdf',
      parseData: (data?: InfoProcura) => {
        // Converto il base64 in un Uint8Array (Blob)
        if (!data?.datiProcura?.fileBlob) return null;
        const byteCharacters = atob(data.datiProcura?.fileBlob);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return byteArray;
      },
      textResponse: true,
      onError: (e: any) => {
        // biome-ignore format: <tbd>
        message.error(getNetworkErrorMessage(e, 'Si è verificato un problema durante il download del file'));
      },
    },
  );

  if (!fileId) return null;

  return (
    <Button size="middle" onClick={() => download()} loading={isFetching}>
      <FileOutlined aria-hidden /> Documento di procura
    </Button>
  );
}
